import TopGoodBooks from "./top-good-book.component";

export default TopGoodBooks;
